// src/components/TitleComponent.jsx
import React from "react";
import { Breadcrumb, Typography, Space } from "antd";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

/**
 * Props:
 * - title: string – Haupttitel der Seite.
 * - subTitle: string – Optionaler Untertitel.
 * - breadcrumbItems: Array von Objekten, z. B.:
 *   [{ path: '/', label: 'Home' }, { path: '/dashboard', label: 'Dashboard' }]
 */
const TitleComponent = ({ title, subTitle, breadcrumbItems = [] }) => {
  return (
    <Space
      direction="vertical"
      size="middle"
      style={{
        width: "100%",
        padding: "16px",
        background: "#fff",
        marginBottom: "16px",
      }}
    >
      {breadcrumbItems.length > 0 && (
        <Breadcrumb>
          {breadcrumbItems.map((item, index) => (
            <Breadcrumb.Item key={index}>
              {item.path ? (
                <Link to={item.path}>{item.label}</Link>
              ) : (
                item.label
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}
      <Title level={2}>{title}</Title>
      {subTitle && <Text type="secondary">{subTitle}</Text>}
    </Space>
  );
};

export default TitleComponent;
